<h2 class="admin-terminology-container-title"> <hc-icon fontSet="fa" fontIcon="fa-clipboard"></hc-icon> Terminology </h2>

<hc-tab-set direction="horizontal">
    <hc-tab routerLink="list" tabTitle="Terminology List"></hc-tab>
    <hc-tab routerLink="requests" tabTitle="Change Requests"></hc-tab>
    <hc-tab routerLink="change-log" tabTitle="Change Log"></hc-tab>
</hc-tab-set>